export const sliderConfigurations = [
	{
		config: {
			name: 'Chronik Slider',
			description: '',
			id: 'chronik-slider',
			selector: 'chronik-slider',
			prevButtonClass: 'chronik-slider--prev',
			nextButtonClass: 'chronik-slider--next',
			sliderElementClass: 'slider--element',
		},
		options: {
			slidesPerView: 1,
			initialSlide: 0,
			autoplay: false,
			prevButton:
				'[data-slider-button-prev-identifier="chronik-slider-button-prev"]',
			nextButton:
				'[data-slider-button-next-identifier="chronik-slider-button-next"]',
			speed: 500,
			loop: true,
			centered: false,
			breakpoints: {
				992: {
					slidesPerView: 1,
				},
			},
		},
		callbacks: {
			slideChange: ['refreshAdditionalContent'],
		},
	},
];
